import React from "react";

const formatNumber = (value, isMoney = false) => {
  if (value === null || value === undefined) return isMoney ? "$0" : "0";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  const formatted = num.toLocaleString("es-EC");
  return isMoney ? `$${formatted}` : formatted;
};

const accentMap = {
  blue: { bg: "#e0ecff", fg: "#1d4ed8" },
  violet: { bg: "#ebe9ff", fg: "#6d28d9" },
  green: { bg: "#e5f8f2", fg: "#0f766e" },
  amber: { bg: "#fff4e0", fg: "#c2410c" },
  aqua: { bg: "#e0f7ff", fg: "#0ea5e9" },
  coral: { bg: "#ffe7e2", fg: "#dc2626" },
};

export default function ContractsTab({ contratos = {} }) {
  const kpis = contratos.kpis || [];
  const sinContrato = contratos.sinContrato || [];
  const recientes = contratos.recientes || [];

  return (
    <>
      <div className="row g-3 admin-kpi-row">
        {kpis.map((kpi) => (
          <div className="col-12 col-sm-6 col-lg-3" key={kpi.label}>
            <div className="admin-kpi-card h-100">
              <div className="admin-kpi-body">
                <span
                  className="admin-kpi-icon"
                  style={{
                    backgroundColor: accentMap[kpi.accent]?.bg || "#e5e7eb",
                    color: accentMap[kpi.accent]?.fg || "#0f172a",
                  }}
                >
                  <i className={`bi ${kpi.icon || "bi-file-earmark-text"} me-0`} />
                </span>
                <div className="admin-kpi-text">
                  <p className="admin-kpi-label mb-0">{kpi.label}</p>
                  <div className="admin-kpi-value">{formatNumber(kpi.value, kpi.isMoney)}</div>
                  <div className="admin-kpi-helper">{kpi.helper}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card admin-section-card mt-3">
        <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
          <div>
            <h6 className="mb-0">Matriculas sin Contrato</h6>
            <small className="text-muted">Activas o reservadas sin contrato generado</small>
          </div>
          <span className="dashboard-chip">
            <i className="bi bi-exclamation-triangle me-1" />
            {sinContrato.length}
          </span>
        </div>
        <div className="table-responsive">
          <table className="table align-middle mb-0">
            <thead>
              <tr>
                <th>Matricula</th>
                <th>Estudiante</th>
                <th>Promocion</th>
                <th>Fecha Matricula</th>
                <th>Estado Pago</th>
               {/*  <th className="text-end">Accion</th> */}
              </tr>
            </thead>
            <tbody>
              {sinContrato.length ? (
                sinContrato.map((m) => (
                  <tr key={m.matricula_id}>
                    <td>{m.codigo_matricula || m.codigoMatricula || m.matricula_id}</td>
                    <td>{m.estudiante}</td>
                    <td>{m.promocion}</td>
                    <td>{m.fecha_matricula}</td>
                    <td>{m.estado_pago || "N/D"}</td>
                    {/* <td className="text-end">
                      <button type="button" className="btn btn-sm btn-primary">
                        Generar contrato
                      </button>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-3">
                    Todas las matriculas tienen contrato
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card admin-section-card mt-3">
        <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
          <div>
            <h6 className="mb-0">Contratos Recientes</h6>
            <small className="text-muted">Ultimos generados</small>
          </div>
          <span className="dashboard-chip">
            <i className="bi bi-clock-history me-1" />
            {recientes.length}
          </span>
        </div>
        <div className="table-responsive">
          <table className="table align-middle mb-0">
            <thead>
              <tr>
                <th>Contrato</th>
                <th>Matricula</th>
                <th>Estudiante</th>
                <th>Version</th>
                <th className="text-end">Pagado</th>
                <th className="text-end">Saldo</th>
              </tr>
            </thead>
            <tbody>
              {recientes.length ? (
                recientes.map((c, idx) => (
                  <tr key={c.id}>
                    <td>{idx + 1}</td>
                    <td>{c.codigo_matricula || c.codigoMatricula || c.numero || c.matricula_id}</td>
                    <td>{c.estudiante}</td>
                    <td>{c.version}</td>
                    <td className="text-end">{formatNumber(c.pagado, true)}</td>
                    <td className="text-end">{formatNumber(c.saldo, true)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-3">
                    Sin contratos recientes
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

